import { tRule } from './types/rules';

const rules: tRule[] = [
  {
    description: 'Todos',
    id: 'all',
    ref: 'none',
    isArray: false,
  },
  {
    description: 'Por Usuarios',
    id: 'users',
    ref: 'user_ids',
    isArray: true,
  },
  {
    description: 'Por Comercios',
    id: 'commerces',
    ref: 'commerce_ids',
    isArray: true,
  },
  {
    description: 'Por Sucursales',
    id: 'branches',
    ref: 'branch_ids',
    isArray: true,
  },
  {
    description: 'Por Categoria',
    id: 'commerce_kinds',
    ref: 'commerce_kind_ids',
    isArray: true,
  },
  {
    description: 'Monto transaccionado',
    id: 'transactions_amount',
    ref: 'transaction_amount_cents',
    isArray: false,
  },
  {
    description: 'Número de transacciones',
    id: 'transactions_count',
    ref: 'transactions_count',
    isArray: false,
  },
  {
    description: 'Ticket promedio en las últimas transacciones',
    id: 'average_amount',
    ref: 'average_amount_cents',
    isArray: false,
  }
];

export { rules };
